import React, { useEffect, useRef, useState } from "react";
import { GET_ATHLETES_SIMPLE } from "../athlete/AthleteUtil";
import { useQuery } from "@apollo/client";
import Loader from "../common/Loader";
import { Link } from "react-router-dom";
import AthleteRow from "../athlete/AthleteRow";
import ClubRow from "../club/ClubRow";
import { GET_CLUBS_SIMPLE } from "../club/ClubUtil";
import { GET_COMPETITIONS_SIMPLE } from "../competition/CompetitionUtil";
import CompetitionRow from "../competition/CompetitionRow";

export const NavbarSearchIcon = ({
  searchActive,
  setSearchActive,
  className,
}) => {
  return (
    <div className={`${className}`} style={{ cursor: "pointer" }}>
      <i
        className={`fa-solid fa-search text-white`}
        style={{ fontSize: "1.2rem" }}
        onClick={() => setSearchActive(!searchActive)}
      ></i>
    </div>
  );
};

export const NavbarSearch = ({ className, setSearchActive }) => {
  const [token, setToken] = useState("");
  const [isSearching, setIsSearching] = useState(false);
  const inputRef = useRef(null);

  //set Focus on init
  useEffect(() => {
    inputRef.current.focus();
  });

  useEffect(() => {
    if (token.length > 3) {
      setIsSearching(true);
    } else {
      setIsSearching(false);
    }
  }, [token]);

  const { data: dataAthletes, loading: loadingAthletes } = useQuery(
    GET_ATHLETES_SIMPLE,
    {
      variables: {
        limit: 10,
        offset: 0,
        filter: {
          fullname: token,
        },
        sort: [["scores.general", "DESC"]],
      },
      skip: !isSearching,
    }
  );

  const { data: dataCompetitions, loading: loadingCompetitions } = useQuery(
    GET_COMPETITIONS_SIMPLE,
    {
      variables: {
        limit: 10,
        offset: 0,
        filter: {
          name: token,
        },
        sort: [["start_date", "DESC"]],
      },
      skip: !isSearching,
    }
  );

  const { data: dataClubs, loading: loadingClubs } = useQuery(
    GET_CLUBS_SIMPLE,
    {
      variables: {
        limit: 10,
        offset: 0,
        filter: {
          name: token,
        },
        sort: [["name", "ASC"]],
      },
      skip: !isSearching,
    }
  );

  return (
    <div className="position-relative w-100 ">
      <div
        className={`position-absolute top-0 start-0 w-100 ${className} `}
        style={{ zIndex: 1000 }}
      >
        <div className="container p-O bg-light pb-3">
          <div className="">
            <input
              type="text"
              ref={inputRef}
              className="form-control"
              placeholder="Rechercher un athlète, une compétition, un club..."
              value={token}
              onChange={(e) => setToken(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Escape") {
                  setSearchActive(false);
                  setToken("");
                }
              }}
            />
          </div>

          {isSearching && (
            <div
              className="border p-1 pb-3 bg-light "
              style={{ minHeight: "200px" }}
              onClick={() => setSearchActive(false)}
            >
              <div className="row">
                <div className="col-md-4 border-end mb-3">
                  <div className="fw-bold text-center">Athletes</div>
                  {loadingAthletes && <Loader className="my-3" />}
                  {dataAthletes?.athletes?.items?.length === 0 && (
                    <div className="text-center text-muted pt-4">
                      Aucun résultat
                    </div>
                  )}
                  {!loadingAthletes &&
                    dataAthletes?.athletes?.items?.map((athlete) => (
                      <AthleteRow athlete={athlete} key={athlete.id} />
                    ))}
                  {dataAthletes?.athletes?.items?.length >= 10 && (
                    <Link
                      className="text-center w-100 d-block"
                      to={`/athletes?fullname=${token}`}
                    >
                      Afficher plus de résultats
                    </Link>
                  )}
                </div>
                <div className="col-md-4 border-end  mb-3">
                  <div className="fw-bold text-center">Compétitions</div>
                  {loadingCompetitions && <Loader className="my-3" />}
                  {dataCompetitions?.competitions?.items?.length === 0 && (
                    <div className="text-center text-muted pt-4">
                      Aucun résultat
                    </div>
                  )}
                  {!loadingCompetitions &&
                    dataCompetitions?.competitions?.items?.map(
                      (competition) => (
                        <CompetitionRow
                          competition={competition}
                          key={competition.id}
                        />
                      )
                    )}
                  {dataCompetitions?.competitions?.items?.length >= 10 && (
                    <Link
                      className="text-center w-100 d-block"
                      to={`/competitions?name=${token}`}
                    >
                      Afficher plus de résultats
                    </Link>
                  )}
                </div>
                <div className="col-md-4 mb-3">
                  <div className="fw-bold text-center">Clubs</div>
                  {loadingClubs && <Loader className="my-3" />}
                  {dataClubs?.clubs?.items?.length === 0 && (
                    <div className="text-center text-muted pt-4">
                      Aucun résultat
                    </div>
                  )}
                  {!loadingClubs &&
                    dataClubs?.clubs?.items?.map((club) => (
                      <ClubRow club={club} key={club.id} />
                    ))}
                  {dataClubs?.clubs?.items?.length >= 10 && (
                    <Link
                      className="text-center w-100 d-block"
                      to={`/clubs?name=${token}`}
                    >
                      Afficher plus de résultats
                    </Link>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
